import { Card } from 'antd';
import * as React from 'react';

export const NotFound: React.FC = () => {
    return (
        <Card style={{ textAlign: 'center' }}>
            <h2>Sorry, no such page.</h2>
        </Card>
    )
}